import {
	Button,
	Col,
	Form,
	Input,
	Row,
	Select,
	Space,
} from 'antd';
import type { FC } from 'react';
import { AUTH_SERVICES_BASE_URL } from '@constants/url';
import useAppPermissionForm, { type AppPermissionFormValues } from './useAppPermissionForm';

/**
 * What an app can be granted outright, rather than over a particular object.
 * The value is the API's own name and goes straight into the path:
 * PUT /api/v1/apps/{cid}/permissions/{permission}.
 */
const PERMISSION_OPTIONS = [
	{ value: 'view_all_companies', label: 'View all companies' },
	{ value: 'edit_all_companies', label: 'Edit all companies' },
];

const AppPermissionForm: FC = () => {
	const {
		form,
		grantPermission,
		isSubmitting,
	} = useAppPermissionForm();

	return (
		<Form<AppPermissionFormValues>
			form={form}
			layout="vertical"
			disabled={!AUTH_SERVICES_BASE_URL}
			onFinish={grantPermission}
			data-testid="apps-permission-form"
		>
			<Row gutter={16}>
				<Col
					xs={24}
					md={12}
				>
					<Form.Item
						name="cid"
						label="Client ID"
						rules={[
							{
								required: true,
								whitespace: true,
								message: 'Client ID is required',
							},
						]}
					>
						<Input
							placeholder="Enter Client ID"
							data-testid="apps-permission-cid"
						/>
					</Form.Item>
				</Col>
				<Col
					xs={24}
					md={12}
				>
					<Form.Item
						name="permission"
						label="Permission"
						rules={[{ required: true, message: 'Permission is required' }]}
					>
						<Select
							placeholder="Select a permission"
							options={PERMISSION_OPTIONS}
							data-testid="apps-permission-name"
						/>
					</Form.Item>
				</Col>
			</Row>
			<Space>
				<Button
					type="primary"
					htmlType="submit"
					loading={isSubmitting}
					data-testid="apps-permission-submit"
				>
					Grant
				</Button>
				<Button
					htmlType="button"
					onClick={() => form.resetFields()}
					data-testid="apps-permission-reset"
				>
					Reset
				</Button>
			</Space>
		</Form>
	);
};

export default AppPermissionForm;
